import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=40a5af39&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a5af39"]])

export default __exports__